import { Col, Row, Timeline } from 'antd'
import React from 'react'
import { LocationSelect } from './EditSelects/LocationSelect'
import { CounterPartySelect } from './EditSelects/CounterpartySelect'

export const BackhaulStops = ({ order, isEditingBackhaul }) => {
  const loads = order.loads
  const drops = order.drops

  return (
    <div className='drop-container mt-4'>
      <Timeline>
        {loads.map((load, index) => {
          return (
            <Timeline.Item key={'load' + index} className='load-stop backhaul'>
              <Row style={{ padding: '0.5em 1em' }}>
                <Col span={12}>
                  <div className='load-heading'>LOADING AT</div>
                  {isEditingBackhaul ? (
                    <LocationSelect accessor='load_location' defaultLocation={load.location_name} />
                  ) : (
                    <>
                      <b className='destination-stop-title'>{load.location_name} </b>
                      <p> {load.address}</p>
                      <p>
                        {load.city} {load.state}
                      </p>
                    </>
                  )}
                </Col>
                <Col span={12} align='right'>
                  <div className='detail-data-label'> Origin Counterparty</div>
                  {isEditingBackhaul ? (
                    <CounterPartySelect
                      accessor='load_counterparty'
                      defaultCounterparty={load.details[0].counterparty}
                    />
                  ) : (
                    <h2 className='detail-data-value'>{load.details[0].counterparty}</h2>
                  )}
                </Col>
              </Row>
            </Timeline.Item>
          )
        })}
        {drops.map((drop, index) => {
          return (
            <Timeline.Item key={'drop' + index} className='drop-stop backhaul'>
              <Row style={{ padding: '0.5em 1em' }}>
                <Col span={12}>
                  <div className='drop-heading'>DROPPING AT</div>
                  {isEditingBackhaul ? (
                    <LocationSelect accessor='drop_location' defaultLocation={drop.location_name} />
                  ) : (
                    <>
                      <div className='destination-stop-title'>{drop.location_name}</div>
                      <p> {drop.address}</p>
                      <p>
                        {drop.city} {drop.state}
                      </p>
                    </>
                  )}
                </Col>
                <Col span={12} align='right'>
                  <div className='detail-data-label'> Destination Counterparty</div>
                  {isEditingBackhaul ? (
                    <CounterPartySelect
                      accessor='drop_counterparty'
                      defaultCounterparty={order.drops[0].counterparty}
                    />
                  ) : (
                    <h2 className='detail-data-value'>{order.drops[0].counterparty}</h2>
                  )}
                </Col>
              </Row>
            </Timeline.Item>
          )
        })}
      </Timeline>
    </div>
  )
}
